/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ITiposDivisiones from 'Infotrack@Modelos/smartStock/tiposDivisiones/entidades/tiposDivisiones';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<ITiposDivisiones>> => [
    {
        title: formatMessage({ id: 'tiposDivisiones.tipoDivisionDescripcion' }),
        field: 'TipoDivisionDescripcion',
    },
    {
        title: formatMessage({ id: 'productos.estado' }),
        field: 'Estado',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, tiposDivisiones?: ITiposDivisiones) => void,
    cargarTiposDivisiones: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (tiposDivisiones: ITiposDivisiones) => void
): Array<Action<ITiposDivisiones>> => [
    {
        icon: 'refresh',
        onClick: cargarTiposDivisiones,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: 'add',
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as ITiposDivisiones),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },

    {
        icon: () => <DeleteIcon color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as ITiposDivisiones),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<ITiposDivisiones> = {
    maxBodyHeight: '50vh',
};
